var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "salesReport"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchantname),
      callback: function($$v) {
        _vm.merchantname = $$v
      },
      expression: "merchantname"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cart-plus'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.invoiceId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.invoiceIdPlaceholder')
    },
    model: {
      value: (_vm.invoiceid),
      callback: function($$v) {
        _vm.invoiceid = $$v
      },
      expression: "invoiceid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.clientProductIdPlaceHolder')
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingcompanyname),
      expression: "shippingcompanyname"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingcompanyname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listshippingcompanyData), function(shippingcompany_obj) {
    return _c('option', {
      domProps: {
        "value": shippingcompany_obj.shippingcompany
      }
    }, [_vm._v(_vm._s(shippingcompany_obj.shippingcompany))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('salesreport.handoverfromdate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('salesreport.handovertodate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-minus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.b2BOrder')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchbtoborder),
      expression: "searchbtoborder"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "searchbtoborder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchbtoborder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectB2BOrder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("B2B Order")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Non B2B Order")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rtv')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtvType),
      expression: "rtvType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "rtvType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rtvType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectrtvtype')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Accept"
    }
  }, [_vm._v("RTV/Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Reject"
    }
  }, [_vm._v("RTV/Reject")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getSalesReportDataSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('salesreport.salesreportlist')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listSalesReportData.length > 0) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-319px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listSalesReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1 "
  }, [(_vm.listSalesReportData.length) ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-200px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getSalesReportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listSalesReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1 "
  }, [(_vm.listSalesReportData.length) ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download Excel"
    },
    on: {
      "click": function($event) {
        _vm.getSalesReportDataForXLS(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listSalesReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.orderItemId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('cancelPutawayPendingReport.productQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.activemrp')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('salesreport.orderdatetime')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('salesreport.handoverdatetime')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('warehouses.warehouseName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannel')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.merchantName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.manifestid')))])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientandWarehouseHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.searchButtoForRecord')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('removeHold.noPutAwayrecordfound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSalesReportData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.itemid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingcompany))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.dispatcheddatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.warehouseid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.manifestid))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listSalesReportData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d045932", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d045932","hasScoped":true}!./src/views/components/reports/salesReport/salesReport.component.html
// module id = 1457
// module chunks = 0